<template>
  <b-modal id="modal" size="xl" button-size="sm" centered header-bg-variant="secondary" header-text-variant="light"
    header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc>
    <template v-slot:modal-header="">
      <h5>Detalhes da alteração</h5>
    </template>
    <div>
      <b-row>
        <b-col class="fieldColumn">
          <span><b>Código</b></span>
          <span class="pos-left">{{ cargo.codigo }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Nomenclatura</b> </span>
          <span class="pos-left">{{ cargo.nomenclatura }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Situação da Vaga</b> </span>
          <span class="pos-left">{{ cargo.situacao }}</span>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="fieldColumn">
          <span><b>Tipo de Vínculo</b></span>
          <span class="pos-left">{{ cargo.vinculo }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Tipo de Regime Jurídico</b> </span>
          <span class="pos-left">{{ cargo.regimeJuridico }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Natureza do Cargo</b></span>
          <span class="pos-left">{{ cargo.natureza }}</span>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <!-- <b-col class="fieldColumn">
          <span><b>Especialidade</b></span>
          <span class="pos-left">{{ cargo.especialidade }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Área</b> </span>
          <span class="pos-left">{{ cargo.area }}</span>
        </b-col> -->
        <b-col class="fieldColumn">
          <span><b>Escolaridade Exigida</b></span>
          <span class="pos-left">{{ cargo.escolaridade }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Regime Previdenciário</b> </span>
          <span class="pos-left">{{ cargo.regimePrevidenciario }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Quantidade de Vagas</b> </span>
          <span class="pos-left">{{ cargo.quantidadeVagas }}</span>
        </b-col>
      </b-row>
      <!--<b-row class="mt-4">
        
        <b-col class="fieldColumn">
          <span><b>Habilitação Exigida</b> </span>
          <span class="pos-left">{{ cargo.habilitacaoExigida ? cargo.habilitacaoExigida : '-' }}</span>
        </b-col> 
        
      </b-row> -->
      <!-- <b-row class="mt-4">
        <b-col class="fieldColumn">
          <span><b>Idade Mínima</b></span>
          <span class="pos-left">{{ cargo.idadeMinima ? cargo.idadeMinima : '-' }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Idade Máxima</b> </span>
          <span class="pos-left">{{ cargo.idadeMaxima ? cargo.idadeMaxima : '-' }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Teto Remuneratório Específico</b> </span>
          <span class="pos-left">{{ cargo.tetoRemuneratorioEspecifico ? cargo.tetoRemuneratorioEspecifico : '-' }}</span>
        </b-col>
      </b-row> -->
      <b-row class="mt-4">
        <b-col class="fieldColumn">
          <span><b>Carga horária Semanal</b></span>
          <span class="pos-left">{{ cargo.cargaHoraria ? cargo.cargaHoraria : '-' }}</span>
        </b-col>
        <b-col class="fieldColumn">
          <span><b>Situação no TCE-SE</b> </span>
          <span class="pos-left">{{ cargo.situacaoNoTCE }}</span>
        </b-col>
        <b-col v-if="cargo.justificativaCorrecao" class="fieldColumn">
          <span><b>Justificativa da Correção</b> </span>
          <span class="pos-left">{{ cargo.justificativaCorrecao }}</span>
        </b-col>
        <b-col v-else></b-col>
      </b-row>
      <div v-if="temNormativo === true">
        <br /><br />
        <h5>Informações do Normativo</h5>
        <b-row class="mt-4">
          <b-col class="fieldColumn">
            <span><b>Número</b> </span>
            <span class="pos-left">{{ cargo.normativo.numero }}</span>
          </b-col>
          <b-col class="fieldColumn">
            <span><b>Ano</b> </span>
            <span class="pos-left">{{ cargo.normativo.ano }}</span>
          </b-col>
          <b-col class="fieldColumn">
            <span><b>Data de Início de Vigência</b> </span>
            <span class="pos-left">{{
                cargo.normativo.dataInicioVigencia
            }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col class="fieldColumn">
            <span><b>Veículo de Publicacao</b> </span>
            <span class="pos-left">{{
                cargo.normativo.veiculoPublicacao
            }}</span>
          </b-col>
          <b-col class="fieldColumn">
            <span><b>Tipo de ato Normativo</b> </span>
            <span class="pos-left">{{ cargo.normativo.tipoAlteracao }}</span>
          </b-col>
          <b-col class="fieldColumn">
            <span><b>Tipo de alteração</b> </span>
            <span class="pos-left">{{ cargo.tipoAlteracao }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col class="fieldColumn">
            <span><b>Número de Vagas criadas ou reduzidas</b> </span>
            <span class="pos-left">{{ cargo.vagasCriadasOuReduzidas }}</span>
          </b-col>
          <b-col></b-col>
          <b-col></b-col>
        </b-row>
      </div>
    </div>
    <template v-slot:modal-footer="">
      <b-button size="sm" variant="outline-secondary" @click="fecharModal()">
        <font-awesome-icon icon="chevron-left" class="mr-2" />Voltar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import cargoService from "@/services/atos-pessoal/cargoService"
import { UtilsTS } from '@/utilsts';

export default {
  name: "ModalAlteracaoCargo",
  props: ["idAlteracao"],
  mixins: [UtilsTS],
  data() {
    return {
      cargo: {
        codigo: "",
        nomenclatura: "",
        regimeJuridico: "",
        regimePrevidenciario: "",
        natureza: "",
        especialidade: "",
        area: "",
        escolaridade: "",
        habilitacaoExigida: "",
        quantidadeVagas: "",
        idadeMinima: "",
        idadeMaxima: null,
        tetoRemuneratorioEspecifico: "",
        situacao: "",
        situacaoNoTCE: "",
        tipoAlteracao: "",
        cargaHoraria: null,
        normativo: {
          numero: "",
          ano: "",
          dataInicioVigencia: "",
          veiculoPublicacao: "",
          tipoAlteracao: "",
        },
        vagasCriadasOuReduzidas: "",
        justificativaCorrecao: "",
      },
      temNormativo: false,
    };
  },
  methods: {
    async loadData() {
      await this.getCargo();
    },
    async getCargo() {
      const response = await cargoService.getCargo(this.idAlteracao);

      if (response && response.status == 200) {
        const c = response.data;
        this.cargo.codigo = c.DeCodigoCargo;
        this.cargo.nomenclatura = c.DeNomenclaturaCargo ? c.DeNomenclaturaCargo.toUpperCase() : '-';
        this.cargo.vinculo = c.IdTipoVinculoNavigation.DeTipoVinculo;
        this.cargo.regimeJuridico =
          c.IdTipoRegimeJuridicoNavigation.DeTipoRegimeJuridico;
        if (c.IdTipoRegimePrevidenciarioNavigation != null) {
          this.cargo.regimePrevidenciario =
            c.IdTipoRegimePrevidenciarioNavigation.DeTipoRegimePrevidenciario;
        }
        this.cargo.natureza = c.IdNaturezaCargoNavigation.DeNaturezaCargo;
        this.cargo.especialidade = c.DeEspecialidade ? c.DeEspecialidade.toUpperCase() : '-';
        this.cargo.area = c.DeArea ? c.DeArea.toUpperCase() : '-';
        this.cargo.escolaridade =
          c.IdTipoEscolaridadeNavigation.DeTipoEscolaridade;
        this.cargo.habilitacaoExigida = c.DeHabilitacaoExigida;
        this.cargo.quantidadeVagas = c.NrQuantidadeVagas;
        this.cargo.idadeMinima = c.NrIdadeMinima;
        this.cargo.idadeMaxima = c.NrIdadeMaxima;
        this.cargo.tetoRemuneratorioEspecifico = c.DeTetoRemuneratorioEspecifico;
        this.cargo.situacao = c.IdSituacaoCargoNavigation.DeSituacaoCargo;
        this.cargo.situacaoNoTCE = c.IdSituacaoCargoTceNavigation.DeSituacao;
        this.cargo.tipoAlteracao = c.IdTipoAlteracaoNavigation != null ? c.IdTipoAlteracaoNavigation.DeAlteracao : null;
        this.cargo.justificativaCorrecao = c.DeJustificativaCorrecao;
        this.cargo.cargaHoraria = c.NrCargaHoraria;
        if (c.Normativo.length > 0) {
          this.temNormativo = true;
          this.cargo.normativo.numero = c.Normativo[0].NrNumeroNormativo;
          this.cargo.normativo.ano = c.Normativo[0].NrAnoNormativo;
          this.cargo.normativo.dataInicioVigencia = c.Normativo[0]
            .DtDataInicioVigenciaNormativo
            ? this.formatData(
              c.Normativo[0].DtDataInicioVigenciaNormativo
            )
            : "-";
          this.cargo.normativo.veiculoPublicacao =
            c.Normativo[0].DeVeiculoPublicacao;
          this.cargo.normativo.tipoAlteracao = await this.formatTipoAtoNormativo(
            c.Normativo[0].IdTipoAtoNormativo
          );
        }
        this.cargo.vagasCriadasOuReduzidas = c.NrVagasCriadasOuReduzidas
          ? c.NrVagasCriadasOuReduzidas
          : "-";
      }
      else {
        this.$toast.error('Erro ao obter os dados do cargo');
      }
    },
    fecharModal() {
      this.$bvModal.hide("modal");
      this.$router.go(-1);
    },
    async formatTipoAtoNormativo(idTipo) {
      const tabelasAuxiliares = await cargoService.getTabelasAuxiliares();
      return tabelasAuxiliares.data.tipoAtoNormativo.find(
        (t) => t.Id == idTipo
      ).Descricao;
    },
    checkNumeroDeVagas() {
      let min = 1;
      let max = 99999;

      if (this.cargo.quantidadeVagas.toString().replace(".", "") > max)
        this.cargo.quantidadeVagas = max

      if (this.cargo.quantidadeVagas.toString().replace(".", "") < min)
        this.cargo.quantidadeVagas = min

      var rx = /(\d+)(\d{3})/;
      this.cargo.quantidadeVagas = String(this.cargo.quantidadeVagas).replace(/^\d+/, function (w) {
        while (rx.test(w)) {
          w = w.replace(rx, '$1.$2');
        }
        return w;
      });
    }
  },

  async created() {
    await this.loadData();
    this.checkNumeroDeVagas();
    this.$bvModal.show("modal");
  },
};
</script>

<style>
.fieldColumn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style> 
